import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import type { DateTime } from 'luxon';
import { toDateTime } from '@shared/utils/date-time';

@Pipe({
    name: 'appMinutesDiff'
})
export class MinutesDiffPipe implements PipeTransform {
    transform(first: DateTime | string, second: DateTime | string): number {
        if (!first || !second) {
            return undefined;
        }

        first = toDateTime(first);
        second = toDateTime(second);

        if (!first?.isValid || !second?.isValid) {
            return undefined;
        }

        return Math.round(first.diff(second, 'minutes').minutes);
    }
}
